import styled from "styled-components";
import { LogoImage } from "../data";
export const Container = styled.div`
  width: auto;
  height: auto;
  padding: 0 10px;
  margin-bottom: 30px;
  @media (max-width: 770px) {
    flex-direction: column;
  }
`;
export const Logo = styled.span`
  width: 35px;
  height: 39px;
  display: block;
  background-image: url(${LogoImage});
  background-size: cover;
  background-position: center;
`;
export const LinkedInLogo = ({ width, height }) => {
  return (
    <>
      <img width={width} height={height} src="./assets/LinkedIn.png" alt="" />
    </>
  );
};
const ButtonCSS = styled.a`
  padding: 5px 20px;
  background: #2c1250;
  border: 1px solid #693b93;
  border-radius: 10px;
  color: #fff;
  margin: 20px 10px;
  cursor: pointer;
  display: inline-block;
  z-index: 99;
  :disabled {
    background-image: url("./assets/loading-gif.gif");
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
  }
`;
export const Button = ({ value, link }) => {
  return (
    <>
      <ButtonCSS target="_blank" href={link}>
        {value}
      </ButtonCSS>
    </>
  );
};
const ButtonCSSInputType = styled.input`
  padding: 5px 20px;
  background: #2c1250;
  border: 1px solid #693b93;
  border-radius: 10px;
  color: #fff;
  margin: 20px 10px;
  cursor: pointer;
  display: inline-block;
  z-index: 99;
  :disabled {
    background-image: url("./assets/loading-gif.gif");
    background-position: center;
    background-size: 20px;
    background-repeat: no-repeat;
  }
`;
export const ButtonInput = ({ value, onClick, disabled }) => {
  return (
    <>
      <ButtonCSSInputType
        type="button"
        onClick={onClick}
        disabled={disabled}
        value={disabled ? "" : value}
      />
    </>
  );
};

const SmartInputCSS = styled.input`
  width: 75%;
  border: 1px solid #693b93;
  background-color: transparent;
  color: #fff;
  padding: 10px;
  margin: 5px 10px;
  border-radius: 10px;
  outline: none;
`;
export const SmartInput = ({ type, placeholder, onChange }) => {
  return (
    <SmartInputCSS
      type={type}
      placeholder={placeholder}
      onChange={onChange}
    ></SmartInputCSS>
  );
};
